import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";

interface IPromptFragmentForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const PromptFragmentForm: React.FC<IPromptFragmentForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Code"
          className="w-full"
          {...form.register("code", { required: "Code requis" })}
          placeholder="stickynav"
        />
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
          placeholder="Navigation sticky"
        />
        <Textarea
          label="Prompt"
          className="w-full"
          rows={4}
          {...form.register("promptText", { required: "Prompt requis" })}
          placeholder="Ajoute une navigation sticky..."
        />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
